import { getSelectedWarehouse } from "@crescentParts/Services/SelectedWarehouseInventoryService";
import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { CartResult, getCart, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { chain, GetCart } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";

type HandlerType = Handler<
    | ({
          cartId: string;
          shouldLoadFullCart?: boolean;
          getPromotions?: boolean;
      } & HasOnSuccess)
    | ({
          apiParameter: GetCartApiParameter;
      } & HasOnSuccess),
    {
        apiParameter: GetCartApiParameter;
        apiResult: CartResult;
        needFullCart: boolean;
    }
>;

export const GetCartWithSelectedWarehouse: HandlerType = async props => {
    const selectedWarehouse = getSelectedWarehouse(props.getState());

    if (selectedWarehouse) {
        props.apiParameter.additionalQueryStringParameters = {
            ...(props.apiParameter.additionalQueryStringParameters ?? {}),
            selectedWarehouse,
        };
    }

    try {
        props.apiResult = await getCart(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 404 || error.status === 403)) {
            props.dispatch({
                type: "Data/Carts/FailedToLoadCart",
                cartId: props.apiParameter.cartId,
                status: error.status,
            });
            return false;
        }
        throw error;
    }
};

replaceInChain(chain, GetCart, GetCartWithSelectedWarehouse);